/**
 * The survey a login started from, taken from the page it redirects back to.
 * Survey links carry a 12-character public id (/surveys/YxosEjvo5VT6); older
 * ones carry the numeric id (/surveys/123). The API accepts either.
 *
 * @param {string | null | undefined} redirectPath
 * @returns {string} the survey id, or '' when the path isn't a survey
 */
export const getRedirectSurveyId = (redirectPath) => {
  const match = (redirectPath || '').match(/\/surveys\/([A-Za-z0-9]+)/)
  return match ? match[1] : ''
}

/**
 * The project a login started from, taken from the page it redirects back to.
 * Project links carry the project's UUID (/projects/82a31c82-e13a-44e1-…).
 *
 * @param {string | null | undefined} redirectPath
 * @returns {string} the project id, or '' when the path isn't a project
 */
export const getRedirectProjectId = (redirectPath) => {
  const match = (redirectPath || '').match(
    /\/projects\/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})(?=[/?#]|$)/i
  )
  return match ? match[1] : ''
}
